import { Partner } from './Partner';

export enum CallToActionPosition {
    FOOTER = 'FOOTER',
    TAB = 'TAB',
}

export enum CallToActionType {
    STATIC = 'url',
    EMAIL = 'email',
    PARTNER = 'partner',
    RETAILER_CART = 'retailerCart',
    NONE = 'none',
}

export interface ICallToAction {
    ctaType: CallToActionType,
    label: string,
    url: string,
    emailSubject: string,
    emailBody: string,
    partner: Partner,
    showCheckoutTotal: boolean,
}
